import React from "react";
import DisplayBanks from "../displayBanks/DisplayBanks";
import DisplayContactCategories from "../displayContactCategories/DisplayContactCategories";
import DisplayPhases from "../displayPhases/DisplayPhases";
import DisplayPropertyTypes from "../displayPropertyTypes/DisplayPropertyTypes";
import DisplayUnits from "../displayUnits/DisplayUnits";
import DisplayUsers from "../displayUsers/DisplayUsers";
import { useListsPermissions } from "../../../auth/hooks/useListsPermissions";
import "./DisplayLists.css";

function DisplayLists() {
  const {
    canViewBanks,
    canViewUnits,
    canViewPropertyTypes,
    canViewContactCategories,
    canViewUsers,
    canViewPhaseLists,
  } = useListsPermissions();

  return (
    <>
      <div>
        <div className="main-container-homepage">
          {canViewBanks && (
            <DisplayBanks />
          )}
          {canViewUnits && (
            <DisplayUnits />
          )}
          {canViewPropertyTypes && (
            <DisplayPropertyTypes />
          )}
          {canViewContactCategories && (
            <DisplayContactCategories />
          )}
          {canViewPhaseLists && <DisplayPhases />}
          {canViewUsers && (
            <DisplayUsers />
          )}
        </div>
      </div>
    </>
  );
}

export default DisplayLists;
